import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {textMetadata} from '../../../../../utils/builderMetadata'

export type TextsSettingsParams = {
  titleText: SettingsParamType.Text
  titleRequestText: SettingsParamType.Text
  buttonLabelText: SettingsParamType.Text
  buttonLabelRequestText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  titleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.title'),
    metadata: textMetadata(
      'uou-reservations.reservation-details.title',
      'Page title when the reservation is confirmed instantly',
    ),
  },
  titleRequestText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.title.request'),
    metadata: textMetadata(
      'uou-reservations.reservation-details.title.request',
      'Page title when the reservation is a request that needs approval',
    ),
  },
  buttonLabelText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.complete.cta'),
    metadata: textMetadata(
      'uou-reservations.reservation-details.complete.cta',
      'Text on the button that completes the reservation',
    ),
  },
  buttonLabelRequestText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.complete.cta.request'),
    metadata: textMetadata(
      'uou-reservations.reservation-details.complete.cta.request',
      'Text on the button that sends the reservation request',
    ),
  },
})
